<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >公告管理</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入内容"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button status="success" @click="add"
                                    >新增</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        class="mytable-scrollbar"
                        ref="table"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column title="编辑" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editBulletin(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="删除" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeBulletin(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="title"
                            title="标题"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="enabledPopupName"
                            title="是否弹窗"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="popupBegin"
                            title="弹窗开始时间"
                            width="120"
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="popupEnd"
                            title="弹窗结束时间"
                            width="120"
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="dayPopupTimes"
                            title="每日弹窗次数"
                            width="120"
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="creator"
                            title="创建人"
                            width="100"
                        ></vxe-column>

                        <vxe-column
                            field="createTime"
                            title="创建时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="activeName"
                            title="是否启用"
                            width="100"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <vxe-modal
                :title="formTitle"
                v-model="formInput.isShow"
                width="1000"
                height="620"
                show-footer
                show-zoom
                resize
                remember
            >
                <template #default>
                    <div>
                        <vxe-form
                            :data="formInput.formData"
                            :rules="formInput.formRules"
                            ref="rForm"
                        >
                            <vxe-form-item
                                title="标题"
                                field="title"
                                span="16"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.title"
                                        placeholder="请输入标题"
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="是否启用"
                                field="active"
                                span="4"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-select v-model="data.active" clearable>
                                        <vxe-option
                                            value="0"
                                            label="否"
                                        ></vxe-option>
                                        <vxe-option
                                            value="1"
                                            label="是"
                                        ></vxe-option>
                                    </vxe-select>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="是否弹窗"
                                field="enabledPopup"
                                span="4"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-select
                                        v-model="data.enabledPopup"
                                        clearable
                                        placeholder="请选择"
                                    >
                                        <vxe-option
                                            value="0"
                                            label="否"
                                        ></vxe-option>
                                        <vxe-option
                                            value="1"
                                            label="是"
                                        ></vxe-option>
                                    </vxe-select>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="每日弹窗次数"
                                field="dayPopupTimes"
                                span="6"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.dayPopupTimes"
                                        type="integer"
                                        min="0"
                                        placeholder="请输入每日弹窗次数"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>

                            <vxe-form-item
                                title="弹窗开始时间"
                                field="popupBegin"
                                span="6"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.popupBegin"
                                        type="date"
                                        placeholder="请选择弹窗开始时间"
                                        clearable
                                        transfer
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="弹窗结束时间"
                                field="popupEnd"
                                span="6"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.popupEnd"
                                        type="date"
                                        placeholder="请选择弹窗结束时间"
                                        clearable
                                        transfer
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="弹窗停留秒数"
                                field="closeSecond"
                                span="6"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.closeSecond"
                                        type="integer"
                                        min="0"
                                        placeholder="请输入弹窗停留秒数"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="内容"
                                field="contents"
                                span="24"
                                :item-render="{}"
                            >
                                <template #default="">
                                    <div style="height: 320px">
                                        <QuillEditor
                                            ref="quill"
                                            toolbar="full"
                                        />
                                    </div>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                </template>
                <template #footer>
                    <div style="text-align: center; width: 100%">
                        <vxe-button
                            :loading="submitting"
                            @click="save"
                            icon="fa fa-save"
                            status="success"
                            >保存
                        </vxe-button>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive } from "vue";
import VXETable from "vxe-table";

export default {
    name: "Bulletin",
    components: {},
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            formData: {
                searchKey: "",
            },
        });

        // const modules = {
        //   name: 'blotFormatter',
        //   module: BlotFormatter,
        //   options: {/* options */}
        // }
        const formInput = reactive({
            isShow: false,
            editType: "1",
            formData: {
                id: "",
                title: "",
                contents: "",
                active: "",
                dayPopupTimes: 1,
                popupBegin: "",
                popupEnd: "",
                enabledPopup: "0",
                closeSecond: 10,
                creator: "",
                modifier: "",
                type: "1", //公告
            },
            formRules: {
                title: [{ required: true, message: "标题不能为空" }],
                active: [{ required: true, message: "不能为空" }],
                dayPopupTimes: [
                    { required: true, message: "每日弹窗次数不能为空" },
                ],
                popupBegin: [
                    { required: true, message: "弹窗开始时间不能为空" },
                ],
                popupEnd: [{ required: true, message: "弹窗结束时间不能为空" }],
                enabledPopup: [{ required: true, message: "启用弹窗不能为空" }],
                closeSecond: [
                    { required: true, message: "弹窗停留秒数不能为空" },
                ],
            },
        });

        return {
            tableData: null,
            tablePager,
            toolbar,
            // modules,
            formInput,
            formTitle: "新增公告",
            pageHeight,
            tableHeight: 0,
        };
    },
    methods: {
        add() {
            this.formInput.isShow = true;
            this.formInput.editType = "1";
            this.formInput.formData = {
                id: "",
                title: "",
                contents: "",
                active: "",
                dayPopupTimes: 1,
                popupBegin: "",
                popupEnd: "",
                enabledPopup: "0",
                closeSecond: 10,
                creator: this.getUserId,
                modifier: this.getUserId,
                type: "1", //公告
            };
            const quill = this.$refs.quill;
            quill.setHTML("");
        },
        editBulletin(row) {
            const params = {
                uid: this.getUserId,
                email: this.getUserEmail,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.id],
            };
            this.formInput.isShow = true;

            this.$api.systemManageAPI
                .getBulletinOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.isShow = true;
                    this.formInput.editType = "2"; //更新
                    this.formInput.formData = res.data.Data.dataTable[0];
                    this.quill = this.$refs.quill;
                    this.quill.setHTML(this.formInput.formData.contents);
                    this.formInput.editType = "2"; //更新
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async removeBulletin(row) {
            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.table;

            if (type === "confirm") {
                this.$api.systemManageAPI
                    .deleteBulletin(Qs.stringify({ bulId: row.id }))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });
                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        async save() {
            const $rForm = this.$refs.rForm;

            this.formInput.formRules.popupBegin[0].required =
                this.formInput.formData.enabledPopup === "1";
            this.formInput.formRules.popupEnd[0].required =
                this.formInput.formData.enabledPopup === "1";

            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            const quill = this.$refs.quill;
            this.formInput.formData.contents = quill.getHTML();

            if (this.formInput.formData.contents === "") {
                VXETable.modal.message({
                    content: "内容不能为空",
                    status: "warning",
                });
                return;
            }

            const params = this.formInput.formData;

            //新增
            if (this.formInput.editType === "1") {
                this.$api.systemManageAPI
                    .addBulletin(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                        this.formInput.isShow = false;
                        this.findData();
                    })
                    .catch((error) => {
                        VXETable.modal.alert({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            } else if (this.formInput.editType === "2") {
                //更新
                this.$api.systemManageAPI
                    .updateBulletin(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                        this.formInput.isShow = false;
                        this.findData();
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            }
        },
        launchToast(toastMsg) {
            this.$vaToast.init({
                message: toastMsg,
                iconClass: this.toastIcon,
                position: this.toastPosition,
                duration: Number(this.toastDuration),
                fullWidth: this.isToastFullWidth,
            });
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [this.toolbar.formData.searchKey],
            };
            this.$api.systemManageAPI
                .getBulletinList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.findData();
        this.formInput.formData.creator = this.getUserId;
        this.formInput.formData.modifier = this.getUserId;
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
    computed: {
        getUserName() {
            return this.$store.state.userName;
        },
        getJobZb() {
            return this.$store.state.jobZb;
        },
        getJobName() {
            return this.$store.state.jobName;
        },
        getUserEmail() {
            return this.$store.state.email;
        },
        getUserId() {
            return this.$store.state.userID;
        },
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
